import isStorageSupported from './isStorageSupported';

export default isStorageSupported;
